
import "./legacy/Polyfills";

import * as React from "react";
import { createRoot } from 'react-dom/client';
import SignInForm from "./components/SignInForm";

if (!(window as any).react) (window as any).react = {};

(window as any).react.sign_in_form = function (target: any, config: any) {
  if (target) {
    const root = createRoot(target);
    return root.render(
      <SignInForm config={config.config} translations={config.translations}/>
    );
  }
};